module.exports = "/packs/logo-sp-01abeb32144a02501087a4af466dd23c.svg";